function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-Issuances_Icon"
}, React.createElement("rect", {
  width: 29,
  height: 20
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Issuances_Icon",
  "data-name": "Issuances Icon",
  clipPath: "url(#clip-Issuances_Icon)"
}, React.createElement("rect", {
  width: 29,
  height: 20,
  fill: "transparent"
}), React.createElement("g", {
  id: "Group_455",
  "data-name": "Group 455",
  transform: "translate(-236.258)"
}, React.createElement("g", {
  id: "Ellipse_1",
  "data-name": "Ellipse 2",
  transform: "translate(245.257)",
  fill: "transparent",
  stroke: "#707070",
  strokeWidth: 2
}, React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  stroke: "none"
}), React.createElement("circle", {
  id: "Ellipse_1_inside",
  cx: 10,
  cy: 10,
  r: 9,
  fill: "none"
})), React.createElement("path", {
  id: "Ellipse_2",
  "data-name": "Path 9",
  d: "M0,1.833s-5.167,3.212-5.167,9.235A9.573,9.573,0,0,0,0,19.5",
  transform: "translate(246.757 -0.5)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1.5
}), React.createElement("path", {
  id: "Ellipse_3",
  "data-name": "Path 10",
  d: "M0,1.833s-5.167,3.212-5.167,9.235A9.573,9.573,0,0,0,0,19.5",
  transform: "translate(242.757 -0.5)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1.5
})));

var SvgIssuance = function SvgIssuance(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIssuance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/issuance.19b97196.svg";
export { ForwardRef as ReactComponent };